"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VechainExecutableContractCall = /** @class */ (function () {
    function VechainExecutableContractCall() {
        this.inputs = [];
    }
    return VechainExecutableContractCall;
}());
exports.VechainExecutableContractCall = VechainExecutableContractCall;
//# sourceMappingURL=VechainExecutableContractCall.js.map